import { Metrics } from '@moonpig/web-core-monitoring'
import { ServerResponse } from 'http'
import { legacyRedirectsConfig } from '@moonpig/web-core-brand/redirects'
import { createLegacyRedirectHandler } from '@moonpig/web-core-redirects'

const redirect = createLegacyRedirectHandler(legacyRedirectsConfig)

export const handleLegacyRedirects = async (
  customAsPath: string,
  res: ServerResponse | undefined,
  metrics: Metrics,
) => {
  if (customAsPath && res && redirect) {
    const redirectResponse = await redirect(customAsPath)
    if (redirectResponse) {
      const source = redirectResponse.source
      const destination = redirectResponse.destination
      const permanent = redirectResponse.permanent
      const statusCode = permanent ? 301 : 302
      res.statusCode = statusCode
      res.setHeader('Location', destination)
      if (permanent) {
        res.setHeader('Cache-Control', 'public, max-age=2628000')
      }
      metrics.count({
        metricName: 'redirect',
        metricCount: 1,
        metricDimensions: {
          source: source.substring(0, 255),
          permanent: permanent ? 'true' : 'false',
        },
      })
      res.end()

      return {
        pageProps: {
          statusCode,
          location: destination,
        },
      } as const
    }
  }
  return null
}
